@import '../../global/common.css';

:host {
    display: block;

    /* Styling for the join-plus-button */
    --plus-wall-join-background-color: var(--secondary-color);
    --plus-wall-join-border: none;
    --plus-wall-join-color: var(--white-color);

    /* Styling for the login link */
    --plus-wall-login-color: var(--text-color);
}

.title {
    margin: 0;

    font-family: Roboto;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    font-feature-settings: 'liga' off, 'clig' off;

    text-align: center;

    color: var(--text-color-2);
}

.subtitle {
    margin: 0;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;

    text-align: center;
    text-transform: uppercase;

    color: var(--text-color);
}

.plus-wall-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin: 0 auto;
    padding: 30px 30px 50px 30px;
    max-width: 655px;

    background-color: var(--background-color);
    border-radius: 10px;
    border: var(--container-border);

    font-family: Roboto;
    color: var(--text-color);
}

.wall-icon {
    align-self: flex-start;
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 30px;

    padding: 5px 50px;
}

.info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.plus-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 30px;

    width: 100%;
    max-width: 305px;
}

.benefits{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.benefit {
    display: flex;
    gap: 5px;

    font-size: 13px;
    font-style: normal;
    font-weight: 400;
}

.plus-actions{
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.plus-actions.align-center{
    align-items: center;
    width: 100%;
}

.join-plus{
    border-radius: 8px;
    border: var(--plus-wall-join-border);
    background-color: var(--plus-wall-join-background-color);

    cursor: pointer;

    min-height: 48px;
    padding: 10px;
    margin: 0px 10px;

    color: var(--plus-wall-join-color);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
}
.join-plus.full-width{
    width: 100%;
}

.login-plus{
    text-align: center;

    color: var(--plus-wall-login-color);
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: var(--plus-wall-login-letter-spacing);
    text-transform: uppercase;
}
.login-plus a{
    cursor: pointer;
    text-decoration: underline;
    color: var(--plus-wall-login-color);
}
